angular
    .module('empower.contactUs')
    .directive('contactUsCustomerCare', [ 'customerCareInfoConst', '$rootScope', 'jurisdictionEnum',
        function (customerCareInfoConst, $rootScope, jurisdictionEnum) {
            return {
                restrict: 'E',
                templateUrl: 'module/contactUs/view/contact-us-customer-care.html',
                scope: true,
                controller: function($scope) {
                    $scope.isClaimant = $rootScope.user.IsClaimant;
                    $scope.isNsi = $rootScope.user.IsNsiUser;
                    $scope.jurisdiction = $rootScope.getSelectedJurisdiction();                    
                    
                    var getCustomerCareInfo = function (jurisdiction, isClaimant, isNsi) {
                        if (isClaimant) {
                            return customerCareInfoConst.WORKER;

                        } else {
                            if(!isNsi) {
                                switch (jurisdiction) {
                                    case jurisdictionEnum.ALL:
                                        return customerCareInfoConst.ALL;
    
                                    case jurisdictionEnum.VIC:
                                        return customerCareInfoConst.VIC;
    
                                    case jurisdictionEnum.NSW:
                                        return customerCareInfoConst.NSW;
                                }
                            } else {
                                return customerCareInfoConst.NSI;
                            }
                        }
                    }

                    $scope.customerCareInfo = getCustomerCareInfo($scope.jurisdiction, $scope.isClaimant, $scope.isNsi);
                }
            }
        }
    ]);